import * as React from 'react';
import { Image, Platform, Keyboard, LayoutAnimation, StatusBar } from 'react-native';
import { Container, Content, Header, Body, Title, Button, Text, View, Icon, Footer, Spinner } from 'native-base';
import styles from './styles';
//import KeyboardSpacer from 'react-native-keyboard-spacer';

class Login extends React.Component<Props, State> {
	// One day we will have animated button https://blog.nativebase.io/react-native-login-logout-animation-722001c8fc55

	/*
	componentWillMount () {
        this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', this._keyboardDidShow.bind(this));
        this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', this._keyboardDidHide.bind(this));
    }

    componentWillUnmount () {
        this.keyboardDidShowListener.remove();
        this.keyboardDidHideListener.remove();
    }
    _keyboardDidShow () {
		LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut)
    }

    _keyboardDidHide () {
        LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut)
    }*/

	render() {
		return (
			<Container style={{ paddingBottom: 10 }}>
				<StatusBar hidden />
				<Content style={{ flex: 1 }} keyboardShouldPersistTaps={'always'} contentContainerStyle={{ flex: 1 }}>
					<Image source={require('../../../assets/cl-1.jpg')} style={{ flex: 1, width: '100%', resizeMode: 'cover' }} />

					<View style={{ flexBasis: 130 }}>{this.props.loginForm}</View>

					<View style={{ width: 200, alignSelf: 'center', flex: 1 }}>
						<Button primary full disabled={this.props.isLoading} style={styles.btn} onPress={() => this.props.onLogin()}>
							{this.props.isLoading ? <Spinner /> : <Text>Login</Text>}
						</Button>
					</View>
				</Content>
				<Footer style={[styles.footer]}>
					<View style={{ alignItems: 'center', opacity: 0.7, flexDirection: 'row' }}>
						<Image source={require('../../../assets/C-32-wh.png')} style={{ width: 30, height: 32 }} />

						<Text style={{ marginLeft: 10, color: '#000' }}>Don't have an account?</Text>
						<Button transparent onPress={() => this.props.navigation.navigate('SignUpContainer')}>
							<Text>Sign Up</Text>
						</Button>
					</View>
				</Footer>
			</Container>
		);
	}
}

export default Login;
